import React, { Component } from 'react';
import Slider from "react-slick";
import {
  isMobile
} from "react-device-detect";
class ModelSide extends Component {

  componentDidMount()
  {
    // idx를 받아와서 정보 재요청한다
    this.currentIndex = 0;
    this.colors = null;
  }
  generateKey()
  {
      return (new Date().getTime()) +  Math.random() * (100 - 0) + 0;
  }
  getHex()
  {
      return this.colors[this.currentIndex].hex;
  }
  getName()
  {
      return window.encodeURI(this.colors[this.currentIndex].name);
  }
  render()
  {
    var model = this.props.select_model, self = this;
    if( model ) {
        let infos = JSON.parse(model.info);
        console.log(model);
        let colors = JSON.parse(model.color), availColors = [];

        if( colors && infos ) {
            for ( let i = 0 ; i < colors.length ; i++)
            {
                if( !colors[i].available )
                {
                    availColors.push(colors[i]);
                } else {
                    if( colors[i].available == 1 )
                    {
                        availColors.push(colors[i]);
                    }
                }
            }
            colors = availColors;
            this.colors = availColors;
          } else {
            colors = [];
            infos = [];
          }
      let settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        afterChange: current => {
          this.currentIndex = current;
        },
        customPaging: function(i) {
          return (
            <a style={{'backgroundColor':'#' + colors[i].hex ,'width':'20px','height':'20px','display':'inline-block'}}>

            </a>);
        }
      };
        return (
          <div>
            <div className="hidden-md bufferModel">
            </div>
            <div className="imgPadding">
            <Slider {...settings}>
              {colors.map(color=>{
                return (
                  <div key={color.hex} className="text-center" >
                    <img className={ (isMobile) ? '' : 'maxWith340'} src={"https://api.tfamily.co.kr/uploads/device/"+self.props.select_model_idx+"_"+color.hex+".jpg"} />
                  </div>
                )
              })}
            </Slider>
            </div>
            <div style={{paddingTop: '40px'}}>
            {(this.colors && this.colors.length != 1) ? <div style={{textAlign:'center'}}> <b>&nbsp;&nbsp;색상을 확인해주세요</b></div> : null}
            </div>
            <div className="modelTitle">
            {model.name}
            </div>
            <div className="modelContent">
              <table className="table modeldetail">
                <tbody>
                { infos.map(info=>{
                  return(<tr key={'info'+ this.generateKey()}>
                    <td style={ {width : '100px', color: 'gray', fontWeight: 'bold' } }>
                      {info.field}
                    </td>
                    <td style= { {fontWeight:'bold'} }>
                      {info.value}
                    </td>
                  </tr>)
                })}
                </tbody>
              </table>
            </div>
          </div>
        )
    } else {
        return (<div></div>)
    }

  }
}

export default ModelSide;
